import Image from 'next/image';

import React, { ReactElement } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { css } from '@emotion/react';
import { ShareDataType } from '@type/web/product';

import useShare from '@hook/share/useShare';

import ThumbnailImage from '@components/common/Image/ThumbnailImage';

import icShareFacebook from '@asset/icons/icShareFacebook.png';
import icShareKakao from '@asset/icons/icShareKakao.png';
import icShareUrl from '@asset/icons/icShareUrl.png';

interface ShareModalType {
  shareData: ShareDataType;
  imgUrl?: string;
  shareMessage?: string;
}

function ShareModalV3({
  shareData,
  shareMessage,
  imgUrl,
}: ShareModalType): ReactElement {
  const {
    Toast,
    handleShareFacebook,
    handleShareKakao,
    handleCopyUrl,
    sharedUrl,
  } = useShare(shareData);

  return (
    <>
      {imgUrl && (
        <ThumbnailImage
          src={imgUrl}
          alt={shareMessage || '공유하기'}
          style={css`
            width: 100%;
          `}
        />
      )}
      <div
        css={css`
          padding-top: 30px;
        `}
      >
        <h2>{shareMessage}</h2>
        <div css={wrapperStyle}>
          <ul css={shareUrlBoxStyle}>
            <li>
              <button
                type="button"
                aria-label="kakaoShare"
                onClick={handleShareKakao}
                data-id="shareV3_kakao"
              >
                <Image
                  width={100}
                  height={100}
                  src={icShareKakao}
                  alt="카카오톡 공유하기"
                />
              </button>
            </li>
            <li>
              <button
                type="button"
                aria-label="fbShare"
                onClick={handleShareFacebook}
                data-id="shareV3_facebook"
              >
                <Image
                  width={100}
                  height={100}
                  src={icShareFacebook}
                  alt="페이스북 공유하기"
                />
              </button>
            </li>
            <li>
              <CopyToClipboard
                text={sharedUrl}
                onCopy={handleCopyUrl}
                data-id="shareV3_URL"
              >
                <Image
                  width={100}
                  height={100}
                  src={icShareUrl}
                  alt="Url 복사하기"
                />
              </CopyToClipboard>
            </li>
          </ul>
        </div>
      </div>

      <Toast>복사 되었습니다</Toast>
    </>
  );
}

const wrapperStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 1rem;
`;

const shareUrlBoxStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;

  & li {
    cursor: pointer;
  }
  button {
    background-color: transparent;
    margin-right: 20px;
  }
  img {
    width: 54px;
    height: 54px;
    height: auto;
  }
`;

export default ShareModalV3;
